<div class="icon-area" (click)="op.toggle($event);" [pTooltip]="label" tooltipPosition="left">
  <div class="icon">
    <fa-icon size="lg" [icon]="icon"></fa-icon>
  </div>
  <p-popover appendTo="body" [styleClass]="'navbar-dropdown'" #op>
    <ng-template pTemplate="content">
      @for (link of links; track link) {
        <div class="item" (click)="navigateTo(op, link.url)">{{ link.label }}</div>
      }
    </ng-template>
  </p-popover>
</div>
